import React from 'react'
import { ReactComponent as TeamSVG } from '../../../assets/images/team-illustration.svg'

interface TeamProps extends React.SVGProps<SVGSVGElement> {
  clothesColor: string
  skinColor: string
  redPuzzleColor: string
  lightPuzzleColor: string
  jeansColor: string
}

const TeamIllustration: React.FC<TeamProps> = ({
  clothesColor,
  skinColor,
  redPuzzleColor,
  lightPuzzleColor,
  jeansColor,
  ...props
}) => {
  // Function to set the fill color of specific paths representing clothes
  const customizeClothesColor = (svg: React.ReactNode) => {
    return React.cloneElement(svg as React.ReactElement, {
      style: {
        '--clothes-color': clothesColor,
        '--skin-color': skinColor,
        '--red-puzzle-color': redPuzzleColor,
        '--light-puzzle-color': lightPuzzleColor,
        '--jeans-color': jeansColor,
      } as React.CSSProperties,
    })
  }

  return customizeClothesColor(<TeamSVG {...props} />)
}

export default TeamIllustration
